__turbopack_context__.v({
  "action": "NotFound-module__Q-axBG__action",
  "container": "NotFound-module__Q-axBG__container",
  "content": "NotFound-module__Q-axBG__content",
  "logoWrapper": "NotFound-module__Q-axBG__logoWrapper",
  "text": "NotFound-module__Q-axBG__text",
  "title": "NotFound-module__Q-axBG__title",
});
